"use strict";

class SuperMetadataController {

    constructor($scope, $timeout, SSHttpService, SSUtilService, SSDateService, SSAwsService, SSAppService, SSAlertService, SSUserService, SSConfigService, SSConfirmationService) {
        const self = this;

        self.$scope = $scope;
        self.$timeout = $timeout;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSDateService = SSDateService;
        self.SSAwsService = SSAwsService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.SSConfigService = SSConfigService;
        self.SSConfirmationService = SSConfirmationService;

        self.data = SHOWSUITE.data;

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        let self = this;

        self.metadataTypes = null;

        self.metadata  = null;
        self.searchName = null;
        self.typeFilter = null;

        self.response = null;

        self.selectedPage = 1;
        self.apiOffset = 0;
        self.apiLimit = 10;

        self.rowLimit = 10;

        self.serverOnlyOptions = [

            {
                'id': 0,
                'name': 'NO'
            },

            {
                'id': 1,
                'name': 'YES'
            }

        ]

        self.metadataTypes = [
            {'id': SHOWSUITE.UNIT_GROUND_TYPE_FLOORING,
            'name': 'UNIT FLOORING'
            },
            {'id': SHOWSUITE.UNIT_GROUND_TYPE_TILING,
                'name': 'UNIT TILING'
            }
        ];
        self.$timeout(function() { $("select.dashboard-select#metadata-type-select").niceSelect('update'); });

        self.errorMessage = false;

        self.errTitle = '';
        self.errContent = '';
        self.errCatId = '';
        self.getMetadata();

    }

    metadataTypeToName(type){

        for(let i=0; i<this.metadataTypes.length; i++){
            if(this.metadataTypes[i].id === type)
                return this.metadataTypes[i].name;
        }
    }

    getMetadata(){
        let self = this;

        let url = 'sec/super/metadata/';

        if(self.searchName != null && self.searchName !== "") {
            console.log("Condition meet and searchName is: " + self.searchName);
            self.selectedPage = 1;
            self.apiOffset = 0;
        }

        let params = {
            offset: self.apiOffset,
            limit: self.apiLimit,
            send_total_count: 1,
            searchName: self.searchName,
            type: self.typeFilter
        }

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.clear();

            self.response = response.data;
            self.metadata = response.data.metadata;
            //console.log(self.metadata);

            self.count = response.data.total_count;
            self.pages = Math.ceil(self.count / self.apiLimit);
            self.selectedPage = Math.floor(self.apiOffset / self.apiLimit) + 1;
            self.pagesArr = [];

            for (var i = 0; i < self.pages; i++) {
                self.pagesArr.push(i);
            }
        });
    }

    pagesGoBack() {
        const self = this;

        self.selectedPage--;
        self.apiOffset = self.apiOffset - self.apiLimit;
        //self.loadEois();
        self.getMetadata();
    }

    pagesGoNext() {
        const self = this;

        self.selectedPage++;
        self.apiOffset = self.apiOffset + self.apiLimit;
        //self.loadEois();
        self.getMetadata();
    }

    gotoPage(pageNum){
        const self = this;

        self.apiOffset = parseInt(pageNum) * self.apiLimit;
        //self.loadEois();
        self.getMetadata();
    }

    updateRowLimit(){
        const self = this;

        self.apiOffset = 0;
        self.selectedPage = 1;
        self.apiLimit = parseInt(self.rowLimit);
        self.getMetadata();
    }



    initMetadataFields(){
        let self = this;
        if(!self.entry){
            self.entry = {};
        }

        if(!self.entry.type){
            self.entry.type = self.metadataTypes[0]['id'];
        }

        if(!self.entry.code){
            self.entry.code = '';
        }

        if(!self.entry.name){
            self.entry.name = '';
        }
        if(!self.entry.description){
            self.entry.description = '';
        }
        if(!self.entry.server_only){
            self.entry.server_only = self.serverOnlyOptions[0]['id'];
        }

        if(!self.entry.data){
            self.entry.data = '';
        }
    }

    toggleEditContainer() {
        const self = this;
        self.initMetadataFields();
        self.metadataDetailsModal = !self.metadataDetailsModal;
        jQuery('#metadataDetailsModal').modal(self.metadataDetailsModal ? 'show' : 'hide');

    }

    open(entry) {

        const self = this;
        self.$timeout(function() { $("select.dashboard-select#add-metadata-type-select").niceSelect('update'); });


        if (entry) {
            self.entry = angular.copy(entry);
        }
        else{
            self.entry = null;
        }
        self.errorMessage = false;

        self.errType = '';
        self.errCode = '';
        self.errName = '';
        self.errDescription = '';

        self.toggleEditContainer();
    }


    postMetadata() {
        const self = this;

        if (!self.validateMetadata()) return;

        self.errorMessage = false;
        let url = 'sec/super/metadata/';

        loading(true);
        self.SSHttpService.postAPIRequest(url, self.entry).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Created successfully.');

            let entry = response.data;

            if (!self.entry.id) {
                self.metadata.push(entry);
            } else {
                jQuery.each(self.metadata, function (i, e) {
                    if (e.id == entry.id) {
                        angular.merge(e, entry);
                        return false;
                    }
                });
            }

            self.toggleEditContainer();
        });
    }

    putMetadata() {
        console.log("I am in putMetadata method");
        const self = this;

        if (!self.validateMetadata()) return;
        self.errorMessage = false;
        let url = 'sec/super/metadata/';

        loading(true);
        self.SSHttpService.putAPIRequest(url, self.entry).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            self.SSAlertService.success('Updated successfully.');

            let entry = response.data;

            if (!self.entry.id) {
                self.metadata.push(entry);
            } else {
                jQuery.each(self.metadata, function (i, e) {
                    if (e.id == entry.id) {
                        angular.merge(e, entry);
                        return false;
                    }
                });
            }

            self.toggleEditContainer();
        });
    }

    validateMetadata() {
        const self = this;

        let error = false;
        self.errDescription ='';
        self.errType ='';
        self.errCode ='';

        if (!self.entry.id && !self.entry.type) {
            self.errType = 'Type is required';
            error = true;
        }

        if (!self.entry.code) {
            self.errCode = 'Code is required';
            error = true;
        }

        if (!self.entry.name) {
            self.errName = 'Name is required';
            error = true;
        }

        if (self.entry.description && self.entry.description.length > 500) {
            self.errDescription = 'Description is maximum 500 characters';
            error = true;
        }

        return !error;
    }


    removeMetadata(entry) {
        const self = this;
        self.SSConfirmationService.getConfirmed(
            'Confirm!',
            'Are you sure you want to delete this metadata constant?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/super/metadata/delete';
                let params = {
                    id: entry.id
                };

                loading(true);
                self.SSHttpService.getAPIRequest(url, params).then(function (response) {
                    loading(false);
                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        return;
                    }
                    jQuery.each(self.metadata, function (i, e) {
                        if (e.id == entry.id) {
                            self.metadata.splice(i, 1);
                            return false;
                        }
                    });
                    self.SSAlertService.success('Removed successfully.');
                });
            }
        );
    }


}

SuperMetadataController.$inject = ['$scope', '$timeout', 'SSHttpService', 'SSUtilService', 'SSDateService', 'SSAwsService', 'SSAppService', 'SSAlertService', 'SSUserService', 'SSConfigService', 'SSConfirmationService'];
app.controller('SuperMetadataController', SuperMetadataController);

